export { default } from './PageActionsDictionary.vue'
